module.exports = __webpack_public_path__ + "static/media/logo-dif-2024.5742f38d.jpeg";